$(document).on('change', '[data-update-cart-position-dimension-select]', function() {
  const itemid = $('option:selected', this).attr('data-item-id');
  const mutable = $('option:selected', this).attr('data-mutable');
  // const quantity = $('option:selected', this).attr('data-quantity');
  const dimensionunit = $('option:selected', this).attr('data-dimension_unit');
  const serialnumber = $('option:selected', this).attr('data-serial_number');
  const form = $(this).closest('form');
  const pospk = form.attr('data-pk');
  $(`#item_id_${pospk}`).val(itemid);

  $(`#dimension_is_mutable_${pospk}`).val(mutable);
  $(`#dimension_quantity_${pospk}`).val($(this).val());
  $(`#dimension_unit_${pospk}`).val(dimensionunit);
  $(`#serial_number_${pospk}`).val(serialnumber);
  if (serialnumber) {
    $(`#quantity-${pospk}`).val(1);
  }
  if (mutable === '1') {
    $(`#dimension_quantity_${pospk}`).attr('name', '');
    $(`#mutable_dimension_quantity_${pospk}`).attr('name', 'dimension_quantity');
  } else {
    $(`#dimension_quantity_${pospk}`).attr('name', 'dimension_quantity');
    $(`#mutable_dimension_quantity_${pospk}`).attr('name', '');
  }
  $(this).submit();
});
